import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Grid, { GridProps } from '@material-ui/core/Grid'

import { IPlayer, PlayerPosition } from 'protos'

import JerseyBack from 'components/JerseyBack'
import GameCardContent from '../GameCardContent'

interface Props extends GridProps {
  team: IPlayer[]
}

const styles = createStyles({
  root: {
    paddingLeft: '4%',
    paddingRight: '4%',
    paddingBottom: 1,
  },
  player: {
    overflow: 'hidden',
  },
  name: {
    fontSize: 11,
    marginTop: 10
  },
  jersey: {
    width: 54,
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardTeam: React.SFC<InjectedProps> = ({
  team,
  classes,
  className,
  ...props
}) => {
  return (
    <GameCardContent
      className={classNames(className, classes.root)}
      wrap="nowrap"
      separated
      {...props}
    >
      {
        team.map((player, i) => {
          return (
            <Grid className={classes.player} key={`player-${player.playerId || i}`} xs={3} item>
              <Grid direction="column" alignItems="center" wrap="nowrap" container>
                <Grid xs item>
                  <Typography className={classes.name} align="center" variant="body1" noWrap>
                    {player.name}
                  </Typography>
                </Grid>
                <Grid xs item>
                  <div className={classes.jersey}>
                    <JerseyBack {...player.jersey} isGoalkeeper={player.position === PlayerPosition.PP_GOALKEEPER} />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          )
        })
      }
    </GameCardContent>
  )
}

export default withStyles(styles)(GameCardTeam)
